import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails11 = () => {
  const mycoData = {
    title: "Utpann MYCO",
    category: "Mycorrhizal Bio-Fertilizer",
    description:
      "MYCO (Mycorrhiza) forms a beneficial association with plant roots to enhance water and nutrient absorption, especially phosphorus. It improves root spread, plant stress tolerance, and early crop establishment. Regular use of MYCO leads to healthier plants, better yields, and long-term soil sustainability.",
    price: "900",
    image: "/assets/Product/img11.png",
    priceNote: "Per 100gm Pack (Gujarat) (Inc GST)",
    recommendations: ["All Crops", "Enhance Nutrient Uptake", "Improve Roots"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      {
        label: "Total viable count",
        value: "CFU minimum 10 viable spore/gram",
      },
      {
        label: "Inoculum Potential",
        value:
          "1200 IP per gram of finished products by MNP method with 10 fold dilution",
      },
      { label: "pH", value: "5.0-7.0" },
    ],
    packaging: [
      { label: "Bulk", value: "1000 MT FIBC" },
      { label: "Standard Pack", value: "100gm" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Improve water absorption efficiency",
      "Improves root development and plant growth",
      "Increases nutrient uptake efficiency",
      "Supports sustainable agriculture with eco-friendly biofertilization",
      "Enhance microbial activity in the soil",
      "Promotes early seed germination and plant establishment",
      "Improves soil structure and fertility overtime",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={mycoData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails11;
